var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabbed-link"},_vm._l((_vm.links),function(link){return _c('router-link',{key:link.text,staticClass:"link",attrs:{"to":link.url}},[_vm._v(" "+_vm._s(link.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }